import React from 'react';
import PropTypes from 'prop-types';
import { BaseLink } from '../Link';
import { Button as ChakraButton } from '@chakra-ui/react';
const base = {
  display: 'inline-flex',
  width: '100%',
  minHeight: '14',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'normal',
  fontSize: 'lg',
  textAlign: 'center',
  paddingY: '3',
  paddingX: '2',
  lineHeight: '1.2',
  borderRadius: 0,
  _hover: {
    textDecoration: 'none',
  },
};

const primary = {
  ...base,
  bg: 'orange.500',
  transition: 'background-color .2s',
  _hover: {
    bg: 'orange.400',
  },
};

export const secondary = {
  ...base,
  bg: 'transparent',
  boxShadow: '0 0 0 1px black inset',

  _hover: {
    boxShadow: '0 0 0 2px black inset',
  },
};

const secondaryInverted = {
  ...secondary,
  borderColor: 'white',
  boxShadow: '0 0 0 1px white inset',
  _hover: {
    boxShadow: '0 0 0 2px white inset',
  },
  color: 'white',
};

export const alternative = {
  ...base,
  bg: 'black',
  color: 'white',
  _hover: {
    bg: '#333333',
  },
};

const alternativeInverted = {
  ...base,
  bg: 'white',
  color: 'black',
  _hover: {
    bg: 'gray.500',
  },
};

export const ButtonVariants = {
  primary: 'primary',
  secondary: 'secondary',
  secondaryInverted: 'secondary-inverted',
  alternative: 'alternative',
  alternativeInverted: 'alternative-inverted',
};

const getVariantStyles = (variant) => {
  switch (variant) {
    case ButtonVariants.secondary:
      return secondary;
    case ButtonVariants.secondaryInverted:
      return secondaryInverted;
    case ButtonVariants.alternative:
      return alternative;
    case ButtonVariants.alternativeInverted:
      return alternativeInverted;
    case ButtonVariants.primary:
      return primary;
    default:
      return primary;
  }
};

export const Button = ({
  title,
  isButton,
  variant = ButtonVariants.primary,
  ...props
}) => {
  const Component = isButton ? ChakraButton : BaseLink;
  const styles = getVariantStyles(variant);

  return (
    <Component
      _hover={{ textDecoration: 'none' }}
      textDecoration="none"
      {...styles}
      {...props}
    >
      {title}
    </Component>
  );
};

Button.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(ButtonVariants)),
  isButton: PropTypes.bool,
};
